<template>
    <div>
        <div class="col-md-12 titles">
            <v-toolbar :class="headerClass" dark>
                <v-toolbar-title>Inputs</v-toolbar-title>
                <v-spacer></v-spacer>
                <label v-tooltip:top="{ html: 'Upload File' }" class="btn btn--icon btn--raised pointer" for="file-input">
                    <div class="btn__content">
                    <v-icon>&#xE2C3;</v-icon>
                    </div>
                </label>
                <input id="file-input" type="file" @change="uploadClick($event.target)" style="display:none;"/>
                <v-btn @click="downloadClick" v-tooltip:top="{ html: 'Download File' }" icon><v-icon>&#xE2C0;</v-icon></v-btn>
            </v-toolbar>
        </div>
        <div class="col-md-12">
            <v-expansion-panel>
                <v-expansion-panel-content :class="subheaderClass">
                    <div slot="header" ><icon name="cubes" scale="1"></icon> Dimensions</div>
                    <v-card>
                        <v-card-text class="white content-color">
                            <form class="form-horizontal">
                                <div class="form-group">
                                    <div>
                                        <label for="xAxis" class="col-sm-3 control-label">X Axis</label>
                                        <div class="col-sm-9">
                                            <select v-model="selectedxAxis" @change="changexAxis()" class="form-control select-option" id="xAxis">
                                                <option v-for="vd in data.valueDimensions">{{vd.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="input-dimensions">
                                        <label for="yAxis" class="col-sm-3 control-label">Y Axis</label>
                                        <div class="col-sm-9">
                                            <select v-model="selectedyAxis" @change="changeyAxis()" class="form-control select-option" id="yAxis">
                                                <option v-for="vd in data.valueDimensions">{{vd.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="input-dimensions">
                                        <label for="size" class="col-sm-3 control-label">Size</label>
                                        <div class="col-sm-9">
                                            <select v-model="selectedrAxis" @change="changerAxis()" class="form-control select-option" id="size">
                                                <option v-for="vd in data.valueDimensions">{{vd.name}}</option>
                                            <option v-for="(value, label) in additionalSizeOptions" :key="label">{{ label }}</option>                                            </select>
                                        </div>
                                    </div>
                                    <div class="input-dimensions">
                                        <label for="colour" class="col-sm-3 control-label">Colour</label>
                                        <div class="col-sm-9">
                                            <select v-model="selectedColour" @change="changeColour()" class="form-control select-option" id="colour">
                                                <option v-for="cd in data.categoryDimensions">{{cd.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </div>
        <div class="col-md-12">
            <v-expansion-panel>
                <v-expansion-panel-content :class="subheaderClass">
                    <div slot="header"><icon name="exchange" scale="1"></icon> Filter</div>
                    <v-card>
                        <v-card-text class="white content-color">
                            <v-btn light :ripple="true" @click="resetAll()">Reset All</v-btn>
                                <div v-for="(singleCategory, singleCategoryKey) in data.categoryDimensions">
                                    <v-expansion-panel class="no-shadow-card">
                                        <v-expansion-panel-content class="white content-color">
                                            <div slot="header">{{singleCategory.name}}</div>
                                            <v-card class="no-shadow-card">
                                                <v-card-text class="white content-color">
                                                    <v-btn class="buttonSelect" light :ripple="true" @click="selectAllClick(singleCategoryKey)">Select all</v-btn>
                                                    <v-btn light :ripple="true" @click="selectAllClick(singleCategoryKey)">Reset</v-btn>
                                                    <div v-for="singleFilter in filterData.filter[singleCategoryKey]">
                                                        <div @click="filterChart()">
                                                        <v-checkbox class="check" :tabindex="0" v-bind:label="singleFilter.orderName" v-model="singleFilter.isSelected" hide-details></v-checkbox>
                                                        </div>
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </div>
                                <div v-for="(singleDimension, singleDimensionKey) in data.valueDimensions" v-on:click="sliderStart(singleDimensionKey)">
                                    <v-expansion-panel class="no-shadow-card" >
                                        <v-expansion-panel-content class="white content-color">
                                            <div slot="header">{{singleDimension.name}}</div>
                                            <v-card class="no-shadow-card">
                                                <v-card-text class="white content-color">
                                                    <v-btn light :ripple="true" @click="sliderReset(singleDimensionKey)">Reset</v-btn>
                                                    <range-slider ref="slider" :min="filterData.filter[singleDimensionKey + data.categoryDimensions.length][0].min"
                                                    :value="[filterData.filter[singleDimensionKey + data.categoryDimensions.length][0].values[0], filterData.filter[singleDimensionKey + data.categoryDimensions.length][0].values[1]]"
                                                    :max="filterData.filter[singleDimensionKey + data.categoryDimensions.length][0].max" v-on:input="sliderFilter($event, singleDimensionKey)" v-show="true"></range-slider>
                                                </v-card-text>
                                            </v-card>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </div>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </div>
    </div>
</template>

<script>
import eXcYteD3 from './eXcYteD3.js';
import rangeSlider from '@/components/rangeSlider.vue';

export default {
    components: {
        rangeSlider
    },
    props: [ 'headerClass', 'subheaderClass' ],
    data: function () {
        return {
            selectedxAxis: '',
            selectedyAxis: '',
            selectedrAxis: '',
            selectedColour: '',
            additionalSizeOptions: eXcYteD3.rAdditionalSizeOptions,
            data: '',
            filterData: [],
            selectedFileName: '',
            uploadMessage: '',
            sliderArray: []
        };
    },
    mounted: function () {
        var routeData = this.$route;
        if (routeData.params && routeData.params.fileName) {
            this.selectedFileName = routeData.params.fileName;
        }
        this.$store.dispatch('loadPensionsData', this.selectedFileName).then((response) => {
            this.data = this.$store.getters.getPensionsData;
            this.$store.commit('updateXaxisSelection', this.data.initialX);
            this.$store.commit('updateYaxisSelection', this.data.initialY);
            this.$store.commit('updateRaxisSelection', this.data.initialR);
            this.$store.commit('updateColourSelection', this.data.initialColour);
            eXcYteD3.draw(this.data);
            this.filterData = this.$store.getters.getChartFilter;
            this.selectedxAxis = this.data.initialX;
            this.selectedyAxis = this.data.initialY;
            this.selectedrAxis = this.data.initialR;
            this.selectedColour = this.data.initialColour;
            this.selectedFileName = this.data.fileName;
            for (var i = 0; i < this.data.categoryFilter.length; i++) {
                this.filterData.filter[i] = this.data.categoryFilter[i];
            }
            this.$store.commit('updateChartFilter', this.filterData);
            eXcYteD3.filterChart();
        });
    },
    methods: {
        changexAxis: function () {
            this.$store.commit('updateXaxisSelection', this.selectedxAxis);
            eXcYteD3.onAxisChnaged();
        },
        changeyAxis: function () {
            this.$store.commit('updateYaxisSelection', this.selectedyAxis);
            eXcYteD3.onAxisChnaged();
        },
        changerAxis: function () {
            this.$store.commit('updateRaxisSelection', this.selectedrAxis);
            eXcYteD3.onAxisChnaged();
        },
        changeColour: function () {
            this.$store.commit('updateColourSelection', this.selectedColour);
            eXcYteD3.onAxisChnaged();
        },
        filterChart: function () {
            eXcYteD3.filterChart();
        },
        selectAllClick: function (box) {
            for (var i = 0; i < this.filterData.filter[box].length; i++) {
                this.filterData.filter[box][i].isSelected = true;
            }
            this.$store.commit('updateChartFilter', this.filterData);
            this.filterChart();
        },
        sliderFilter: function (newValue, sliderNumber) {
            this.filterData.filter[this.data.categoryDimensions.length + sliderNumber][0].values[0] = newValue[0];
            this.filterData.filter[this.data.categoryDimensions.length + sliderNumber][0].values[1] = newValue[1];
            this.$store.commit('updateChartFilter', this.filterData);
            this.filterChart();
        },
        uploadClick: function (uploadEvent) {
            const formData = new FormData();
            for (var i = 0; i < uploadEvent.files.length; i++) {
                formData.append(uploadEvent.files[i].name, uploadEvent.files[i]);
            }
            this.$store.dispatch('uploadFile', formData).then((response) => {
                uploadEvent.value = '';
                this.uploadMessage = this.$store.getters.getUploadMessage;
                this.selectedFileName = this.uploadMessage[1];
                if (window.location.href.indexOf('/loadFile/') !== -1) {
                    var baseUrl = window.location.href.replace(this.$route.fullPath, '');
                    window.open(baseUrl + '/loadFile/' + this.selectedFileName, '_self');
                    window.location.reload();
                } else {
                    window.open(window.location.href + 'loadFile/' + this.selectedFileName, '_self');
                    window.location.reload();
                }
            });
        },
        downloadClick: function () {
            this.$store.dispatch('downloadFile', this.selectedFileName);
        },
        resetAll: function () {
            for (var i = 0; i < this.data.categoryDimensions.length; i++) {
                this.selectAllClick(i);
            }
            for (var j = 0; j < this.$refs.slider.length; j++) {
                this.$refs.slider[j].$refs.slider.setCurrentValue(this.$refs.slider[j].max);
                this.$refs.slider[j].$refs.slider.setIndex(0);
            }
        },
        sliderReset: function (key) {
            this.$refs.slider[key].$refs.slider.setCurrentValue(this.$refs.slider[key].max);
            this.$refs.slider[key].$refs.slider.setIndex(0);
        },
        sliderStart: function (key) {
            if (this.sliderArray.indexOf(key) === -1) {
                this.$refs.slider[key].$refs.slider.refresh();
                this.sliderArray.push(key);
            }
        }
    }

};
</script>

<style>
    .input-dimensions {
        padding-top: 50px!important;
    }
    .checkbox {
        padding-top: 0px!important;
        padding-bottom: 0px!important;
    }
    .buttonSelect {
        height: 40px!important;
        border-radius: 20px!important;
        background-color: #00a3c4!important;
        color: white!important;
        box-shadow: 0 0px 0px rgba(0,0,0,0)!important;
    }
    .no-shadow-card {
        box-shadow: 0 0px 5px rgba(0, 0, 0, .1)!important;
    }
    .check, .content-color, .check > label {
        color: #032f5e!important;
    }
    .select-option {
        color: #032f5e!important;
        border-color: #032f5e!important;
        background-color: #f2f2f2!important;
    }
    .select-option > option {
        color: #032f5e!important;
        background-color: white!important;
    }
    .pointer {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// inputSection.vue?e8bb1546